import React from 'react'
import NA from '../not-available'

const ServiceView = ({name, abn, ccb_approval_id}) => (
  <section>
    <dl className="details-card-list">
      <dt>Name</dt>
      <dd>{name || <NA name="Name" />}</dd>

      <dt>ABN</dt>
      <dd>{abn || <NA name="ABN" />}</dd>

      <dt>CCB Approval ID</dt>
      <dd>{ccb_approval_id || <NA name="CCB Approval ID" />}</dd>
    </dl>
  </section>
)

export default ServiceView


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/gov-care-registration/view.jsx